import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  parts: ["mainContainer", "mats", "iconContainer", "icon"],
  baseStyle: {
    mainContainer: {
      display: "inline-flex",
      p: "4px 8px",
      alignItems: "center",
      gap: "4px",
      color: "primary.black.100",
      fontFamily: "riforma.medium",
    },
    iconContainer: {
      display: "inline-flex",
      alignItems: "center",
    },
    icon: {
      width: "16px",
    },
  },
  variants: {
    badge: {
      mainContainer: {
        borderRadius: "40px",
        background: "#DEFF80",
      },
    },
    label: {
      mainContainer: {
        borderRadius: "0",
        background: "none",
      },
    },
    accountPanelLabel: {
      mainContainer: {
        borderRadius: "0",
        background: "none",
      },
    },
    red: {
      mats: {
        color: "primary.red.100",
        fontSize: "48px",
      },
      iconContainer: {
        fontSize: "20px",
        fontWeight: 500,
        lineHeight: "32px",
        opacity: 0.6,
      },
      icon: {
        height: "16px",
        width: "16px",
      },
    },
  },
  sizes: {
    sm: {
      mainContainer: {
        fontSize: "14px",
        lineHeight: "16px",
        fontWeight: 700,
        letterSpacing: "-0,48px",
      },
    },
    md: {
      mats: {
        fontSize: "26px",
        lineHeight: "32px",
        fontWeight: 500,
      },
      iconContainer: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: 500,
      },
    },
    xl: {
      mainContainer: {
        color: "primary.black.80",
        fontWeight: 700,
        fontSize: "32px",
        lineHeight: "40px",
      },
      mats: {
        color: "primary.black.80",
        fontWeight: 500,
        fontSize: "64px",
        lineHeight: "64px",
      },
      icon: {
        width: "24px",
      },
    },
  },
  defaultProps: {
    variant: "badge",
    size: "md",
  },
})

export default theme
